import { Injectable } from '@angular/core';

@Injectable()
export class ConfigurationService {

  public data: any = {
    language: 'pl'
  };

  public baseHref = 'https://graterenowa.nysa.eu/';

  private allowedLanguages = [ 'pl', 'cz' ];

  constructor() {
    if (localStorage.getItem('configuration') === null) {
      this.save();
    } else {
      this.load();
    }
  }

  save() {
    localStorage.setItem('configuration', JSON.stringify(this.data));
  }

  load() {
    this.data = localStorage.getItem('configuration');
    this.data = JSON.parse(this.data);
  }

  public setLanguage(lang) {
    if (this.allowedLanguages.indexOf(lang) !== -1) {
      this.data.language = lang;
    }
    this.save();
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/services/configuration.service.ts